import React from 'react';

const SignIn = ({username, password, onCreateAccount, onLogin, onUsernameChange, onPasswordChange}) => (
  <div className="signin">
    <input className="username" onChange={(event) => { onUsernameChange(event.target.value) }} placeholder="email"/>
    <input className="password" onChange={(event) => { onPasswordChange(event.target.value) }} placeholder="password"/>
    <button className="button" onClick={() => { onCreateAccount(username, password) }}>Create Account</button>
    <button className="button" onClick={() => { onLogin(username, password) }}>Login</button>
  </div>
)

export default SignIn



// WEBPACK FOOTER //
// ./src/components/SignIn.js